/**
 * 法语（fr）
 */
export default {
  billing: {}
}

